const STORAGE_KEY = "servall_visitor";

const readRaw = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) return saved;
    } catch {
        /* ignore */
    }
    try {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        if (saved) {
            try { localStorage.setItem(STORAGE_KEY, saved); } catch { /* ignore */ }
            return saved;
        }
    } catch {
        /* ignore */
    }
    return null;
};

const writeRaw = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
    try { sessionStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
};

export const loadVisitor = () => {
    try {
        const raw = readRaw();
        if (!raw) return null;
        const v = JSON.parse(raw);
        if (!v?.name || !v?.phone) return null;
        return v;
    } catch {
        return null;
    }
};

export const saveVisitor = (patch) => {
    const prev = loadVisitor() || {};
    const next = {
        ...prev,
        ...patch,
        name: (patch.name ?? prev.name ?? "").trim(),
        phone: (patch.phone ?? prev.phone ?? "").trim(),
        purpose: patch.purpose ?? prev.purpose ?? "",
        city: (patch.city ?? prev.city ?? "").trim(),
        email: (patch.email ?? prev.email ?? "").trim(),
    };
    try {
        writeRaw(JSON.stringify(next));
    } catch {
        /* ignore */
    }
    return next;
};

export const VISIT_PURPOSES = [
    { value: "buy", label: "Buy a bike" },
    { value: "test_ride", label: "Book a test ride" },
    { value: "quote", label: "On-road quote" },
    { value: "emi", label: "EMI / finance help" },
    { value: "compare", label: "Compare & decide" },
    { value: "general", label: "General enquiry" },
];

export const purposeLabel = (value) =>
    VISIT_PURPOSES.find((p) => p.value === value)?.label || value || "";

export const hasVisitorProfile = () => {
    const v = loadVisitor();
    return Boolean(v?.name && v?.phone && v?.purpose);
};

export const hasOutletLeadCaptured = () => Boolean(loadVisitor()?.outlet_lead_captured);

export const markOutletLeadCaptured = (leadId = "") =>
    saveVisitor({ outlet_lead_captured: true, outlet_lead_id: leadId });

export const intentToPurpose = (intent) => {
    const map = {
        test_ride: "test_ride",
        pre_book: "buy",
        price_drop: "quote",
        whatsapp_inquiry: "quote",
        loan_inquiry: "emi",
        compare_help: "compare",
        general: "general",
    };
    return map[intent] || "general";
};
